import styled from "styled-components";

export const StyledWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  position: relative;
  z-index: 10;
`;

export const StyledButton = styled.button`
  border: none;
  background: transparent;
  color: ${({ theme }) => theme.colors.neutralsTextLight};
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;

  &:not(.disable) {
    cursor: pointer;
  }

  &.active {
    background: ${({ theme }) => theme.colors.primaryRulerTint15};
    color: ${({ theme }) => theme.colors.neutralsText};
  }
`;
